import {Component, EventEmitter, Input, Output, Type} from '@angular/core';
import {IGetClass, IModalWindow} from '../../../utils/interfaces/modal-dialog.interface';
import {ModalWindowsTypes} from '../../../core/enums';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'asg-delete-file-dialog',
    templateUrl: './delete-file-dialog.component.html',
    styleUrls: ['./delete-file-dialog.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class DeleteFileDialogComponent {
  @Input() ok: () => void;
  @Input() no: () => void;
  @Output() deleteFileFired: EventEmitter<any> = new EventEmitter<any>();
  @Output() returnToCloudDlgFired: EventEmitter<any> = new EventEmitter<any>();

  getWindowType(): Type<IModalWindow> {
    return DeleteFileDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.DELETE_FILE_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  getClass(): string {
    return 'delete-file-dlg';
  }
}
